// import React, { useState, useEffect } from 'react';
// import { Plus, Search } from 'lucide-react';
// import IngestionEntityModal from './popups/IngestionEntityModal';
// import { apiService } from '../../../../components/api/apiService';

// const DataIngestion: React.FC = () => {
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [entities, setEntities] = useState<any[]>([]);
//     const [loading, setLoading] = useState(true);
//     const [searchQuery, setSearchQuery] = useState('');



//     const fetchEntities = async () => {
//         setLoading(true);
//         try {
//             const data = await apiService.get('/Entities', {}, 'backend');
//             setEntities(data.entities || []);
//         } catch (err) {
//             console.error('Error fetching entities:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchEntities();
//     }, []);

//     const handleCreateEntity = async (data: any) => {
//         try {
//             const body = {
//                 sourceName: data.sourceName,
//                 description: data.description,
//                 sourceType: data.sourceType || 'api_rest',
//                 connectionDetails: data.connectionDetails,
//                 tags: data.tags || []
//             };


//             await apiService.post('/Entities', body, 'backend');
//             fetchEntities();
//             setShowAddModal(false);
//         } catch (err) {
//             console.error('Error creating entity:', err);
//         }
//     };

// return (
//         <div className="min-h-screen bg-black text-white p-8">
//             {/* Header section matching SS1 */}
//             <div className="flex justify-between items-start mb-6">
//                 <div>
//                     <h1 className="text-2xl font-bold text-white">Entities</h1>
//                     <p className="text-gray-400 text-sm mt-1">
//                         Manage and monitor data sources connected to SelficAI.
//                     </p>
//                 </div>
//                 <button
//                     onClick={() => setShowAddModal(true)}
//                     className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors"
//                 >
//                     <Plus className="w-4 h-4" />
//                     Add Source
//                 </button>
//             </div>

//             {/* Search Bar matching SS1 */}
//             <div className="relative mb-12">
//                 <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
//                 <input
//                     type="text"
//                     placeholder="Search sources..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                     className="w-full bg-neutral-900 border-none rounded-lg pl-12 pr-4 py-3 text-sm focus:ring-1 focus:ring-indigo-500 outline-none transition-all placeholder:text-gray-600"
//                 />
//             </div>

//             {/* Content Area matching SS1 */}
//             <div className="w-full">
//                 {loading ? (
//                     <div className="flex flex-col items-center justify-center py-32 gap-4">
//                         <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
//                         <p className="text-gray-500 text-sm">Loading entities...</p>
//                     </div>
//                 ) : entities.length === 0 ? (
//                     <div className="flex flex-col items-center justify-center py-32 text-center">
//                         <p className="text-gray-500 text-sm font-medium">No data sources found.</p>
//                     </div>
//                 ) : (
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pb-20">
//                         {entities
//                             .filter(e => (e.sourceName || '').toLowerCase().includes(searchQuery.toLowerCase()))
//                             .map(entity => (
//                                 <div key={entity.id} className="bg-neutral-900 p-5 rounded-2xl border border-neutral-800 flex flex-col gap-4 group hover:border-indigo-500/50 transition-all shadow-sm">
//                                     <div className="flex justify-between items-start">
//                                         <div className="p-2 bg-indigo-500/10 rounded-lg text-indigo-400">
//                                             <Plus className="w-5 h-5 rotate-45" /> {/* Placeholder icon */}
//                                         </div>
//                                         <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase ${entity.status === 'Active' ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500'}`}>
//                                             {entity.status}
//                                         </span>
//                                     </div>
//                                     <div>
//                                         <h3 className="font-bold text-white text-lg">{entity.sourceName}</h3>
//                                         <p className="text-xs text-gray-500 mt-1 line-clamp-2">{entity.description || 'No description provided.'}</p>
//                                     </div>
//                                     <div className="pt-4 border-t border-neutral-800 flex justify-between items-center text-[10px] text-gray-500 uppercase tracking-wider font-bold">
//                                         <span>{entity.sourceType}</span>
//                                         <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
//                                             <button className="text-indigo-400 hover:text-indigo-300">Edit</button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                     </div>
//                 )}
//             </div>

//             {showAddModal && (
//                 <IngestionEntityModal
//                     onClose={() => setShowAddModal(false)}
//                     onSubmit={handleCreateEntity}
//                 />
//             )}
//         </div>
//     );
// };

// export default DataIngestion;



import React, { useEffect, useState } from 'react';
import { PlusCircle, Pencil, Trash2, Sparkles, RefreshCcw, Database, TableProperties, Globe, PlugZap, Upload, Cloud, Server, Table, FileSpreadsheet, Shield, UserCog } from 'lucide-react';
import AddDataSourceModal from './AddDataSourceModal';
import SmartMetadataModal from './SmartMetadataModal';
import { ingestionService } from '../../../../components/api/ingestionService';
import ConfirmDialog from '../../Dialogs/ConfirmDialog';
import RenameModal from '../../common/RenameModal';
import PermissionsAssignmentModal from '../../common/Permissions/PermissionsAssignmentModal';
import IngestionEntityModal from './popups/IngestionEntityModal';
import { apiService } from '../../Connections/connectionsApiService';


const initialDataSources = []

const sourceTypes = [
    { label: 'SqlServer', icon: <Database className="w-4 h-4 mr-2 text-cyan-400" /> },
    { label: 'PostgreSQL', icon: <Database className="w-4 h-4 mr-2 text-cyan-500" /> },
    { label: 'MySQL', icon: <Database className="w-4 h-4 mr-2 text-blue-500" /> },
    { label: 'Oracle', icon: <Database className="w-4 h-4 mr-2 text-red-500" /> },
    { label: 'SQLite', icon: <Database className="w-4 h-4 mr-2 text-gray-400" /> },
    { label: 'NoSQL_MongoDB', icon: <TableProperties className="w-4 h-4 mr-2 text-green-400" /> },
    { label: 'API', icon: <Globe className="w-4 h-4 mr-2 text-yellow-400" /> },
    { label: 'Webhook', icon: <PlugZap className="w-4 h-4 mr-2 text-pink-400" /> },
    { label: 'CSV_Upload', icon: <Upload className="w-4 h-4 mr-2 text-orange-400" /> },
    { label: 'S3_Bucket', icon: <Cloud className="w-4 h-4 mr-2 text-blue-400" /> },
    { label: 'Azure_Blob', icon: <Cloud className="w-4 h-4 mr-2 text-blue-300" /> },
    { label: 'Google_Sheets', icon: <TableProperties className="w-4 h-4 mr-2 text-green-300" /> },
    { label: 'FTP_SFTP', icon: <Server className="w-4 h-4 mr-2 text-purple-400" /> },
    { label: 'Firestore', icon: <TableProperties className="w-4 h-4 mr-2 text-red-400" /> },
    { label: 'Snowflake', icon: <Cloud className="w-4 h-4 mr-2 text-white" /> },
    { label: 'CSV', icon: <Table className="w-4 h-4 mr-2 text-white" /> },
    { label: 'Excel', icon: <FileSpreadsheet className="w-4 h-4 mr-2 text-white" /> }
];

const IngestionList = () => {


    const [activeMetadataSource, setActiveMetadataSource] = useState(null);
    const [search, setSearch] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [dsToDelete, setdsToDelete] = useState(false);
    const [selectedDSID, setSelectedDSID] = useState('')

    // const [dataSources, setDataSources] = useState<any[]>(initialDataSources);
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [renameTarget, setRenameTarget] = useState<{ id: string; name: string } | null>(null);

    const [showAssignmentModal, setAssignmentModal] = useState(false);


    const [dataSources, setDataSources] = useState<any[]>(initialDataSources);
    const loadDataSources = async () => {
        try {
            const tenantId = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
            const apiResults = await ingestionService.loadDataSources(tenantId);

            const mapped = apiResults.map(mapApiToDataSource);

            setDataSources(prev => {
                // const combined = [...prev, ...mapped];
                const combined = [...mapped];
                const unique = Array.from(new Map(combined.map(item => [item.id, item])).values());
                return unique;
            });
        } catch (err) {
            console.error('Failed to load data sources:', err);
        }
    };

    const mapApiToDataSource = (apiItem: any): any => {
        return {
            id: apiItem.id,
            name: apiItem.connectionName,
            type: resolveSourceType(apiItem.sourceType), // convert number to label
            status: apiItem.isActive ? 'Active' : 'Disabled',
            description: apiItem.description || '',
            schedule: 'Manual Trigger', // or use your logic
            tags: apiItem.tags
                ? apiItem.tags
                    .split(',')
                    .map((tag: string) => tag.trim())
                    .filter((tag: string) => Boolean(tag))
                : [],
            lastSynced: apiItem.lastSyncedAt
                ? new Date(apiItem.lastSyncedAt).toLocaleString()
                : 'Never',
        };
    };
    const handleDeleteDataSource = async (id: string) => {
        try {
            const apiResults = await ingestionService.deleteDataSource(id)
            loadDataSources();
            console.log(apiResults);
        } catch (err) {
            console.error('Failed to delete data source:', err);
        }
    }

    // Optional: if sourceType is a number
    const resolveSourceType = (index: number) => {
        const source = sourceTypes[index];
        return source ? source.label : `Type ${index}`;
    };

    useEffect(() => {
        loadDataSources();
    }, []);

    const filtered = dataSources.filter((s) =>
        s.name?.toLowerCase().includes(search.toLowerCase())
    );
    const [entities, setEntities] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const fetchEntities = async () => {
        setLoading(true);
        try {
            const data = await apiService.get('/Entities', {}, 'backend');
            setEntities(data.entities || []);
        } catch (err) {
            console.error('Error fetching entities:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEntities();
    }, []);
    const handleCreateEntity = async (data: any) => {
        try {
            const body = {
                tenantId: 'cd9e8246-872b-4db4-a223-4d0c429260b7',
                sourceType: 17, // File
                connectionName: data.sourceName,
                connectionString: 'string',
                accessKey: 'string',
                secretKey: 'string',
                apiEndpoint: 'string',
                description: data.description,
                authenticationType: 'string',
                additionalParamsJson: 'string',
                fileFormat: 'string',
                schemaDefinitionJson: 'string',
                isDefault: true,
                region: 'string',
                queryOrCommand: 'string',
                objectName: 'string',
                filePathOrUri: 'string',
                queryParametersJson: 'string',
                tags: 'string',
                defaultVectorStore: '05a3cd64-12bb-4e69-8249-3552f3f0002f',
                defaultLLM: '616ec5d3-0594-4662-8190-5cec2edc1618'
            };


            await apiService.post('/DataSource', body, 'backend');
            setTimeout(() => {
                fetchEntities();
                setShowAddModal(false);    
                window.location.reload();
            }, 2000);
        } catch (err) {
            console.error('Error creating entity:', err);
        }
    };
    return (
        <div>
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-xl font-semibold text-white">Data Models</h2>
                    <p className="text-sm text-gray-400">Manage and connect data model entities.</p>
                </div>
                <button onClick={() => setShowAddModal(true)} className="flex items-center bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm shadow">
                    <PlusCircle className="w-4 h-4 mr-2" /> Add Source
                </button>
            </div>
            {/* Search */}
            <div className="mb-6">
                <input
                    type="text"
                    placeholder="Search sources..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full px-4 py-2 rounded-md bg-neutral-800 text-white placeholder-gray-400 focus:outline-none text-sm"
                />
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {filtered.map((source) => (
                    <div
                        key={source.id}
                        className="bg-neutral-900 border border-neutral-800 rounded-lg p-4 hover:border-indigo-500 transition-all"
                    >
                        <div className="flex items-start justify-between">
                            <div>
                                <h3 className="text-white font-medium text-sm">{source.name}</h3>
                                <p className="text-xs text-gray-400 mt-1">{source.description}</p>
                            </div>
                            <Database className="text-indigo-500 w-4 h-4" />
                        </div>

                        <div className="mt-4 space-y-1 text-xs text-gray-300">
                            <div>
                                <span className="text-gray-500">Type:</span> {source.type}
                            </div>
                            <div>
                                <span className="text-gray-500">Status:</span>{' '}
                                <span className={source.status === 'Active' ? 'text-green-400' : 'text-red-400'}>
                                    {source.status}
                                </span>
                            </div>
                            <div>
                                <span className="text-gray-500">Schedule:</span> {source.schedule}
                            </div>
                            <div>
                                <span className="text-gray-500">Last Synced:</span> {source.lastSynced}
                            </div>
                            <div>
                                <span className="text-gray-500">Tags:</span>{' '}
                                {source.tags.map((tag: string) => (
                                    <span
                                        key={tag}
                                        className="inline-block bg-neutral-800 text-gray-300 px-2 py-0.5 rounded-full text-[11px] mr-1"
                                    >
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="flex justify-end gap-2 mt-4">
                            <button
                                className="text-indigo-400 hover:text-indigo-300 transition-colors"
                                title="Manage Permissions & Access"
                                onClick={() => setAssignmentModal(true)}
                            >
                                <UserCog className="w-4 h-4" />
                            </button>
                            <button className="text-indigo-400 hover:text-indigo-300" title="Test Sync">
                                <RefreshCcw className="w-4 h-4" />
                            </button>
                            <button onClick={() => {
                                setRenameTarget({ id: source.id, name: source.name });
                                setShowRenameModal(true);
                            }} className="text-yellow-400 hover:text-yellow-300" title="Edit Source">
                                <Pencil className="w-4 h-4" />
                            </button>
                            <button className="text-red-400 hover:text-red-300"
                                onClick={() => {
                                    setSelectedDSID(source.id)
                                    setdsToDelete(true)
                                }
                                }
                                title="Delete Source">
                                <Trash2 className="w-4 h-4" />
                            </button>
                            <button
                                className="text-red-400 hover:text-red-300"
                                title="Trigger Smart Metadata Detection"
                                onClick={() => setActiveMetadataSource(source)}
                            >
                                <Sparkles className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                ))}

                {filtered.length === 0 && (
                    <div className="col-span-full text-center text-gray-500 py-10">No data sources found.</div>
                )}
            </div>

            {showAddModal && (
                <IngestionEntityModal
                    onClose={() => setShowAddModal(false)} 
                    onSubmit={handleCreateEntity}
                />

            )}
            {dsToDelete && (
                <ConfirmDialog
                    message={`Are you sure you want to delete the data source  and all its documents?`}
                    onYes={() => {
                        handleDeleteDataSource(selectedDSID);
                        setdsToDelete(false);
                    }}
                    onNo={() => setdsToDelete(false)}
                    onCancel={() => setdsToDelete(false)}
                />
            )}

            {activeMetadataSource && (
                <SmartMetadataModal
                    dataSource={activeMetadataSource}
                    onClose={() => setActiveMetadataSource(null)}
                />
            )}

            {renameTarget && showRenameModal && (
                <RenameModal
                    id={renameTarget.id}
                    currentName={renameTarget.name}
                    module="Ingestion Source"
                    onCancel={() => {
                        setShowRenameModal(false);
                        setRenameTarget(null);
                    }}
                    onSave={({ id, newName }) => {
                        ingestionService.renameIngestion({
                            id,
                            tenantID: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                            newTitle: newName,
                        }).then(() => {
                            loadDataSources();
                            setShowRenameModal(false);
                            setRenameTarget(null);
                        });
                    }}
                />
            )}
            {showAssignmentModal && (
                <PermissionsAssignmentModal
                    onClose={() => setAssignmentModal(false)}
                    onSave={() => { }}
                    entityType="entity"
                    entityName="System Entity"
                // Optional: Pass initial permissions
                // initialPermissions={{
                //     departments: [],
                //     users: [],
                //     roles: [],
                //     exclusions: []
                // }}
                />
            )}
        </div>
    );
};

export default IngestionList;
